const shuffle = (users, bins, result = {}) => {
    // End assign bin's
    if (!users.length || !bins.length) {
        return result;
    }

    const sumParts   = bins.reduce((a, b) => a + b.parts, 0);
    const avgPerUser = Math.floor(sumParts / users.length);
    // Remove from next iterations
    const forUser    = users[0];

    const userBins = { bins: [], sumParts: 0 };
    for (const bin of bins) {
        // Prediction factor
        const currentFactor = (100 * userBins.sumParts) / avgPerUser;
        const predictionFactor = (100 * (userBins.sumParts + bin.parts)) / avgPerUser;
        if (predictionFactor > 100 && currentFactor > 20) {
            break;
        }

        userBins.bins.push(bin.location);
        userBins.sumParts += bin.parts;

        // current user parts in % from avg %
        // User have 85% or greater from avg
        if (users && users.length > 1 && predictionFactor >= 85) {
            break;
        }
    }

    // Remove assigned bins
    const remainingBins = bins.filter(bin => !userBins.bins.includes(bin.location));
    // Remove assigned user
    const remainingUsers = users.filter(user => user.UUID !== forUser.UUID);

    // Assign bins to user
    result[forUser.name] = userBins;

    return shuffle(remainingUsers, remainingBins, result);
};

export default shuffle;
